import { createGlobalStyle } from "styled-components"
import { theme } from "Theme"
import AddToCalendarStyles from "./AddToCalendarStyles"
import Carousel from "./Carousel"

const GlobalStyle = createGlobalStyle`

  .hide {
    display: none !important;
  }

  html {
    position: relative;
    min-height: 100%;
    font-display: swap;
    -ms-overflow-style: none;
    &::-webkit-scrollbar {
      display: none;
    }
  }

  body {
    font-display: swap;
    margin: 0;
    margin-bottom: 237px;

    @media (min-width: ${theme.breakpoints.s}) {
    }
    @media (min-width: ${theme.breakpoints.m}) {
      margin-bottom: 90px;
    }
    @media (min-width: ${theme.breakpoints.l}) {
    }
  }

  .btn-close {
    position: fixed;
    top: 10px;
    right: 10px;
    background: #000;
    color: #fff;
    border-radius: ${theme.borderRadius.elements};
    width: 40px;
    height: 40px;
    z-index: 9;
  }

  .svg-icon {
      margin-top:3px;
      &.inline {
        vertical-align: middle;
        margin-top:0;
        margin-bottom:2px;
        font-size:12px;
        &.true {
          color: #f00;
        }
        &.false {
          color: #207520;
        }
      }
  }

  pre {
    border: 1px solid #ccc;
    background: rgba(0, 0, 0, 0.1);
    padding: 20px;
    overflow: scroll;
    margin:0;
  }

  .video-background {
    position: absolute;
    background: #000;
    top: 0;
    bottom: 0;
    right: 0;
    left: 0;
    z-index: 1;
    display:none;
    @media (min-width: ${theme.breakpoints.s}) {
      @media (min-aspect-ratio: 16/9) {
        .video-foreground {
          width: 100%;
          height: 200%;
          top: -45%;
          left: 0%;
        }
      }

      @media (max-aspect-ratio: 16/9) {
        .video-foreground {
          width: 100%;
          height: 360%;
          top: -130%;
          left: 0%;
        }
      }
    }
    @media (min-width: ${theme.breakpoints.m}) {
      display:block;
      @media (min-aspect-ratio: 16/9) {
        .video-foreground {
          width: 100%;
          height: 200%;
          top: -45%;
          left: 0%;
        }
      }

      @media (max-aspect-ratio: 16/9) {
        .video-foreground {
          width: 120%;
          height: 360%;
          top: -130%;
          left: -10%;
        }
      }
    }
    @media (min-width: ${theme.breakpoints.l}) {
      @media (min-aspect-ratio: 16/9) {
        .video-foreground {
          width: 100%;
          height: 170%;
          top: -30%;
          left: 0%;
        }
      }

      @media (max-aspect-ratio: 16/9) {
        .video-foreground {
          width: 100%;
          height: 360%;
          top: -130%;
          left: 0;
        }
      }
    }
  }

  .video-foreground,
  .video-background iframe {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    pointer-events: none;
  }

  img {
    margin: 0;
  }

  iframe {
    margin: 0;
  }

  .video-section-foreground,
  .video-section-background iframe {
    width: 100%;
    position: relative;
    height: 300px;
  }

  .video-section-youtube-foreground,
  .video-section-youtube-background {
    width: 100%;
    iframe {
      width: 100%;
      position: relative;
      min-height: 300px;
    }
  }

  *,
  *:before,
  *:after {
    box-sizing: inherit;
  }

  html {
    -moz-osx-font-smoothing: grayscale;
    -ms-overflow-style: scrollbar;
    -webkit-font-smoothing: antialiased;
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
    box-sizing: border-box;
    overflow-x: hidden;
    text-rendering: optimizeLegibility;
    width: 100%;
    min-height: 100%;
    position: relative;
  }

  body {
    width: 100%;
    height: 100%;
    overflow-x: hidden;
    -moz-osx-font-smoothing: grayscale;
    -webkit-font-smoothing: antialiased;
    &.hidden {
      overflow: hidden;
    }
    &.blur {
      overflow: hidden;
      #root > .container > * {
        filter: blur(5px) brightness(0.7);
        transition: ${theme.transition};
        pointer-events: none;
        user-select: none;
      }
    }

    header {
      transition: all 0.2s ease;
      background: linear-gradient(rgba(0, 0, 0, 0.2),rgba(0, 0, 0, 0.0));
      .hamburger-inner {
        background-color: #ffffff;
        &:before,
        &:after {
          background:#ffffff;
        }
      }
    }
    &.sticky-default {
      header {
        img {
          filter: none;
        }
        box-shadow: 0 5px 30px rgba(0, 0, 0, 0.2);
        background: ${theme.colors.white.base};
        & > nav {
          button,
          a:not(.action-cta),
          .nav-logo {
            color: ${theme.colors.black.base};
          }
        }
        .hamburger-inner {
          background-color: #212121;
          &:before,
          &:after {
            background:#212121;
          }
        }
      }
      .social-network-share-container {
        transform: translateX(0px);
        position: fixed;
        z-index: 9;
        top: 200px;
        right: 10px;
      }
    }
    &.sticky-inverted {
      header {
        img {
          filter: invert(0.8);
        }
        box-shadow: 0 5px 30px rgba(0, 0, 0, 0.2);
        background: ${theme.colors.white.base};
        & > nav {
          button,
          a:not(.action-cta),
          .nav-logo {
            color: ${theme.colors.black.base};
          }
        }
        .hamburger-inner {
          background-color: #212121;
          &:before,
          &:after {
            background:#212121;
          }
        }
      }
      .social-network-share-container {
        transform: translateX(0px);
        position: fixed;
        z-index: 9;
        top: 200px;
        right: 10px;
      }
    }
    .social-network-share-container {
      display: flex;
      flex-direction: column;
      align-items: center;
      position: fixed;
      z-index: 9;
      top: 200px;
      right: 10px;
      transform: translateX(60px);
      transition: all 400ms ease-in-out;
      background: #fff;
      box-shadow: 0px 0px 20px rgba(0,0,0,0.2);
      padding: 4px;
      border-radius: ${theme.borderRadius.elements};
      .social-network-share-button {
        & + .social-network-share-button {
          margin-top: 4px;
        }
      }
    }
  }

  ::selection {
    background-color: ${theme.colors.highlight};
  }

  h1,
  h2,
  h3,
  h4,
  h5 {
    font-weight: bold;
    margin: 0 0 10px 0;
  }

  #root {
    min-height: 100vh;
    display: grid;
    grid-template-rows: 1fr auto;
    grid-template-columns: 100%;
  }

  img {
    width: 100%;
    max-width: 100%;
    vertical-align: middle;
  }

  svg.brand-logo {
    width: 48px;
    height: 100%;
    fill: currentColor;
    vertical-align: middle;
  }

  a {
    display: inline-block;
    text-decoration: none;
    text-decoration-skip-ink: auto;
    color: inherit;
    position: relative;
    transition: ${theme.transition};
    cursor: pointer;
    transition: all ${theme.transitions.default.duration};
    &:hover,
    &:focus {
      color: ${theme.colors.primary.base};
      outline: 0;
    }
  }

  button {
    cursor: pointer;
    border: 0;
    outline: none;
    border-radius: ${theme.borderRadius.elements};
    color: inherit;
    background: none;
  }

  input, textarea {
    border-radius: ${theme.borderRadius.elements};
    outline: 0;

    &:focus {
      outline: 0;
    }
    &::placeholder {
    }
    &:focus,
    &:active {
      &::placeholder {
        opacity: 0.5;
      }
    }
  }

  p {
    margin: 0 0 15px 0;
  }

  ul, ol {
    padding: 0;
    margin: 0;
    list-style: none;
  }

  .share {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin:1rem;
  }

  .links {
    display: flex;
    flex-direction: row;
  }

  .label {
    font-size: 1.2em;
    margin: 0 1em 1em;
  }

  .ReactModal__Overlay {
    z-index:99998;
    opacity: 0;
    transition: opacity 400ms ease-in-out;
    overflow-x: hidden;
    overflow-y: auto;
  }

  .ReactModal__Overlay--after-open{
    opacity: 1;
  }

  .ReactModal__Overlay--before-close{
    opacity: 0;
  }

  .ReactModal__Content {
    position: relative !important;
    border-radius: 0 !important;
    padding: 0 !important;
    border: none !important;
    width: 100%;
    height: 100%;
    top: 0 !important;
    left: 0 !important;
    right: 0 !important;
    bottom: 0 !important;
    transition: all 400ms ease-in-out;
    transform: translateY(30px);
    opacity: 0;
    box-shadow: 0 16px 30px rgba(0,0,0,0.4);
    max-width: ${theme.breakpoints.s};
    margin: 0 auto;

    &--after-open {
      opacity: 1;
      transform: translateY(0);
    }
    &--before-close {
      opacity: 0;
      transform: translateY(30px);
    }


    @media (min-width: ${theme.breakpoints.s}) {
      height: auto;
      border-radius: ${theme.borderRadius.ui} !important;
      max-width: 500px;
      margin: 2rem auto;
    }
    @media (min-width: ${theme.breakpoints.m}) {
      max-width: 600px;
      margin: 2rem auto;
      overflow: hidden !important;
    }
    @media (min-width: ${theme.breakpoints.l}) {
      max-width: 600px;
      margin: 2rem auto;
    }



    section {
      @media (min-width: ${theme.breakpoints.s}) {
        margin: 1rem;
      }
      @media (min-width: ${theme.breakpoints.m}) {
        margin: 2rem;
      }
      @media (min-width: ${theme.breakpoints.l}) {
        margin: 4rem 2rem;
      }
    }

    .hidden-sm {
      display: none;
      @media (min-width: ${theme.breakpoints.s}) {
      }
      @media (min-width: ${theme.breakpoints.m}) {
        display: block;
      }
      @media (min-width: ${theme.breakpoints.l}) {
      }
    }

    @media (min-width: ${theme.breakpoints.s}) {
    }
    @media (min-width: ${theme.breakpoints.m}) {
    }
  }

  .react-tabs {
    padding: 0;
    background: none;
    border-radius: ${theme.borderRadius.ui};
    .react-tabs__tab {
      border-radius: ${theme.borderRadius.elements};
      padding: 0;
    }
    .react-tabs__tab-list {
      margin: 0;
      padding: 0;
      display: flex;
      justify-content: space-evenly;
      border-bottom: 1px solid #aaa;
      margin: 0 0 10px;
      padding: 0;
    }
    .react-tabs__tab {
      color:#000;
      border:none;
      align-self: center;
      margin:0;
      padding:4px;


      display: inline-block;
      border: 1px solid transparent;
      border-bottom: none;
      bottom: -2px;
      position: relative;
      list-style: none;
      padding: 6px 12px;
      cursor: pointer;

      padding: 2px 8px;
      font-size: inherit;
      font-weight: bold;

      &.react-tabs__tab--selected {
        background:#fff;
        border-bottom: none;
      }

      &:focus {
        box-shadow: none;
        &:after {
          content: "";
          position: absolute;
          height: 0px;
          left: -4px;
          right: -4px;
          bottom: -5px;
          background: #fff;
        }
      }
    }
    .react-tabs__tab--selected {
      background: none;
      border-radius: ${theme.borderRadius.ui} ${theme.borderRadius.ui} 0 0;

    }
  }

  .option-card .react-tabs .react-tabs__tab.react-tabs__tab--selected {
    border: 1px solid #ccc;
    border-bottom: none;
  }

  .grid-container {
    width: 100%;
    display: grid;
    grid-gap: 20px;
    grid-template-columns: repeat(4,280px);
  }
  select {
    display: block;
    width: 100%;
    padding: 4px 8px;
    font-size: 14px;
    line-height: 1.5;
    background-color: #fff;
    border: 1px solid #ced4da;
    border-radius: ${theme.borderRadius.default};
  }

  .btn {
    &:focus {
    }
  }
  ${Carousel}
  ${AddToCalendarStyles}
  .countdown-wrapper {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    flex-wrap: wrap;
    margin: 10px 0;
    min-height: 48px;
    @media (min-width: ${theme.breakpoints.s}) {
    }
    @media (min-width: ${theme.breakpoints.m}) {
      margin: 0;
    }
    @media (min-width: ${theme.breakpoints.m}) {
    }
}

.countdown-item {
    color: ${theme.colors.primary.base};
    display: block;
    align-items: center;
    justify-content: center;
    text-align: center;
    margin: 0 4px;
    padding: 0 4px;
    position: relative;
    background-color: #fff;
    border-radius: ${theme.borderRadius.ui};
    font-size: 20px;
    font-weight:bold;
    z-index: 2;
    box-shadow: 0px 6px 30px 6px rgba(0, 0, 0, 0.2);
    width: 48px;
    height: 48px;
    display: flex;
    flex-direction: column;
    box-sizing: content-box;
}

.countdown-item span {
    color: #333;
    font-size: 10px;
    font-weight: bold;
    text-transform: uppercase;
}

.category-tag-list {
  border-radius: ${theme.borderRadius.elements};
}

.event-list-link {
  border-radius: ${theme.borderRadius.elements};
  overflow: hidden;
  z-index:1;
}

.event-list-description-box {
  z-index: 1;
  margin: -34px 0 0;
  @media (min-width: ${theme.breakpoints.s}) {
  }
  @media (min-width: ${theme.breakpoints.m}) {
    border-radius: 0 0 ${theme.borderRadius.ui} ${theme.borderRadius.ui};
  }
  @media (min-width: ${theme.breakpoints.m}) {
  }
  .btn {
    border-radius: ${theme.borderRadius.elements};
    &:hover,
    &:focus,
    &:active {
      color: #ffffff;
      background-color: ${theme.colors.primary.base};
      border-color: transparent;
      outline: 0;
    }
  }
}

.event-list-countdown {
  z-index: 1;
}

.social-network-share-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  position: fixed;
  z-index: 9;
  top: 200px;
  right: 10px;
  transform: translateX(0px);
  transition: all 400ms ease-in-out;
  background: #fff;
  box-shadow: 0px 0px 20px rgba(0,0,0,0.2);
  padding: 4px;
  border-radius: ${theme.borderRadius.elements};
  .social-network-share-button {
    & + .social-network-share-button {
      margin-top: 4px;
    }
  }
}

.social-share-closed {
  .social-network-share-container {
    transform: translateX(0px);
    position: fixed;
    z-index: 9;
    top: 200px;
    right: 10px;
    .social-network-share-button {
      & + .social-network-share-button {
        margin-top: 4px;
      }
    }
  }
}

.bottomBar{
  position: fixed;
  height: 40px;
  left: 0;
  bottom: 0;
  transform: translateY(0px);
  background-color: #fff;
  width: 100%;
  text-align: center;
  font-size: 22px;
  box-shadow: 0px -12px 20px rgba(0,0,0,0.1);
  transition: all ${theme.transitions.default.duration}
  z-index:9;
}

.bottomBarHide{
  transform: translateY(40px);
}

.accordion__item {
  margin-bottom: 8px;
  border: 1px solid #ccc;
  border-radius: ${theme.borderRadius.ui};
}

.accordion__heading {
  background: #e1e1e1;
  border-radius: ${theme.borderRadius.ui};
  &:hover, &:focus {
    background: ${theme.colors.white.light};
    border-radius: ${theme.borderRadius.ui};
    border-color: ${theme.colors.primary.base};
    outline: 0;
    transition: ${theme.transitions.default.transition};
  }
}

.accordion__panel {
  padding: ${theme.padding};
  border-radius: ${theme.borderRadius.ui};
  border-top-left-radius: 0;
  border-top-right-radius: 0;
  text-align: left;
  font-size: ${theme.fontSize.small};
  p {
    margin: 0;
  }
}




.infoBox {
  overflow: visible !important;
  .mapBoxStyle {
    display: inline-block;
    padding: 6px 14px;
    border-radius: ${theme.borderRadius.elements};
    background-color: #FFF;
    box-shadow: ${theme.shadow.event};
    text-align: center;
    font-weight: 700;
    font-size: 16px;
    font-family: sans-serif;
    opacity: 0.7;
  }
  .mapBoxStyle:after, .mapBoxStyle:before {
    position: absolute;
    bottom: 100%;
    left: 0;
    width: 0;
    height: 0;
    border: solid transparent;
    content: " ";
    pointer-events: none;
  }
  .mapBoxStyle:after {
    margin-left: 0;
    border-width: 10px;
    border-color: rgba(0,0,0,0);
  }
  .mapBoxStyle:before {
    margin-left: 0;
    border-width: 10px;
    border-color: rgba(0,0,0,0);
    border-bottom-color: #fff;
  }
}

.calendarModal {
  position: fixed;
  background: #fff;
  max-width: 200px;
  height: 256px;
  border-radius: ${theme.borderRadius.ui};
  outline: none;
  overflow: hidden;
  a {
    padding: 4px 1rem;
    font-size: 10px;
    text-decoration: none;
    text-transform: uppercase;
    text-align: center;
    letter-spacing: 1px;
    color: #2c3e50;
    background-color: transparent;
    border: 1px solid #2c3e50;
    border-radius: ${theme.borderRadius.elements};
    -webkit-transition: 0.25s;
    transition: 0.25s;
    width: 100%;
    margin: 4px 0;
  }
}

.subscribe-form {
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: space-evenly;
  }

  .Toaster {
    z-index: 99999999;
    position: absolute;
    .Toaster__manager-top {
      top: 20px !important;
      max-width: 600px !important;
      background: #fff;
      border-radius: 6px;
      .Toaster__message {
        padding: 10px;
        height: auto !important;
        .Toaster__message-wrapper {
          width: 100%;
          .Toaster__alert {
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            .Toaster__alert_text {
              color: #000;
              margin-right:1rem;
              font-size: 14px;
              font-weight: bold;
              line-height: 30px;
            }
          }
        }
      }
    }
  }

  @-webkit-keyframes autofill {
      to {
          background: transparent;
      }
  }

  input:-webkit-autofill {
      -webkit-animation-name: autofill;
      -webkit-animation-fill-mode: both;
  }
  .dev-mode {
    color: red;
    z-index: 999;
    font-weight: bold;
  }
  #gatsby-plugin-scroll-indicator {
    background-color: ${theme.colors.primary.base} !important;
    z-index: 9999;
  }
  .hamburger-inner {
    background:#000;
    &:before,
    &:after {
      background:#000;
    }
  }

  .react-icons {
    vertical-align: middle;
    margin-right: 4px;
    @media (min-width: ${theme.breakpoints.m}) {
      vertical-align: bottom;
    }
  }

  .smooth-scroll {
    & + hr {
     height:0;
    }
  }

  .btn {
    color: inherit;
    font-size: ${theme.fontSize.small};
    font-weight: normal;
    cursor: pointer;
    white-space: nowrap;
    display: block;
    border-radius: ${theme.borderRadius.elements};
    padding: 12px 18px;
    background: rgba(255, 255, 255, 0.2);
    border-width: 1px;
    border-color: inherit;
    border-style: solid;
    width: 100%;
    text-align: inherit;
    &:hover,
    &:focus {
      color: ${theme.colors.white.base};
      background: ${theme.colors.primary.base};
      border-color: ${theme.colors.primary.base};
      outline: 0;
      box-shadow: ${theme.shadow.feature.small.hover};
    }
    & + button,
    & + a {
      margin: 1rem 0 0 0;
    }
    @media (min-width: ${theme.breakpoints.s}) {
      & + button,
      & + a {
        margin: 1rem 0 0 0;
      }
    }
    @media (min-width: ${theme.breakpoints.m}) {
      font-size: ${theme.fontSize.smallish};
      padding: 6px 18px;
      width: auto;
      display: inline-block;
      text-align: left;
      & + button,
      & + a {
        margin: 0 0 0 8px;
      }
    }
    @media (min-width: ${theme.breakpoints.l}) {
    }
  }

  @keyframes Beat {
    0%   {top: 0px;}
    50%  {top: 10px;}
    100% {top: 0px;}
  }


}

.toast-notification{
  width: 100% !important;
  span {
    width: 90% !important;
    box-shadow: ${theme.shadow.feature.small.default};
    padding: 8px 1rem !important;
    @media (min-width: ${theme.breakpoints.m}) {
      width: auto !important;
    }
  }
}

.play-btn{
  background:none;
  border-radius:0 ${theme.borderRadius.ui} 0 ${theme.borderRadius.ui};
  border:none;
  box-shadow:-6px 6px 22px -5px rgba(0,0,0,0.5);
  font-size: 0px;
  height: 32px;
  overflow:hidden;
  padding:0;
  position: absolute;
  right: -1px;
  top: -1px;
  transform: initial;
  transform:translateZ(0);
  width: 32px;
  z-index: 999999999;
}
.play-btn .play-btn-bg{
    background: #439ce3;
    border-radius:0 ${theme.borderRadius.ui} 0 ${theme.borderRadius.ui};
    border: none;
    content:'';
    display:block;
    height:100%;
    left:50%;
    position:absolute;
    top:50%;
    transform:translate(-50%, -50%);
    width:100%;
    z-index:1;
}
.play-btn-icon{
    fill:white;
    vertical-align: middle;
}
.panel-box{
  background: #439ce3;
  border-radius:0 ${theme.borderRadius.ui} 0 ${theme.borderRadius.ui};
  border:none;
  box-shadow:-6px 6px 22px -5px rgba(0,0,0,0.5);
  color: white;
  height: auto;
  overflow:hidden;
  padding: 1px 1rem;
  position: absolute;
  right: -1px;
  text-align: center;
  top: -1px;
  transform: initial;
  transform:translateZ(0);
  width: auto;
  z-index: 999999999;
}
.time-box{
  background: rgba(0,0,0,0.6);
  border-radius: 0 0 ${theme.borderRadius.ui} ${theme.borderRadius.ui};
  border:none;
  bottom: 0;
  color: white;
  height: auto;
  left: 0px;
  margin: 0;
  overflow:hidden;
  padding: 1px 1rem;
  position: absolute;
  right: 0px;
  text-align: center;
  transform: initial;
  transform:translateZ(0);
  width: auto;
  z-index: 999999999;
}

.animated-section.animated-images {
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0px;
}
`

export default GlobalStyle
